export const privacyUpdatedAt = "2026 年 10 月 26 日";

export const privacySections = [{
    id: "data",
    title: "我们处理的数据",
    items: [
      "学校教务数据：学号、验证码、学校登录状态、课表、成绩、考试、学习计划、毕业要求、空闲教室与教室占用信息来自教务系统。",
      "登录凭据：学校密码会提交给教务系统用于登录，并在设备的系统安全存储中加密保存，用于重新认证；本网站和 MyLeafy 后台不接收学校密码。退出登录会删除保存的学校凭据。",
      "随记与个人日程：默认保存在当前设备。iOS 用户可主动开启 iCloud，同步课表、成绩考试、备注提醒、个人日程、随记及图片附件录音、课表和个性化设置。数据进入当前 Apple 账号的 CloudKit 私有数据库，按校园身份隔离，不通过 MyLeafy 后台中转。Android 免登录入口仅以匿名方式检查应用版本与下载更新，不建立后台账号，也不上传本地记录。",
      "设备数据：最近同步的课程、成绩、课堂笔记、提醒、收藏教室、链接、倒计时、主题偏好、同步时间与失败信息保存在当前设备；未开启 iCloud 时，各设备分别保存数据；Android 数据仍独立保存在本机。",
      "社区资料：匿名社区登录状态、绑定学号、显示名称、昵称、头像、专业、年级、邮箱验证状态与资料更新时间用于建立社区身份。",
      "社区内容：帖子、图片、文档附件、评论、点赞、公告阅读状态、教师星级评价与评价摘要保存在 MyLeafy 社区服务中。",
      "共享课表：分享由你在 App 中主动创建。发布的课表数据包括课程名称、教师、地点、周次、节次、学期与发布时间。",
      "反馈：你提交的反馈、可选联系方式、设备类型、系统版本、App 版本、登录状态与最近课表同步时间用于技术支持。",
      "照片与文件：MyLeafy 只读取你主动选择的内容。用于发帖的图片与附件会上传至社区服务；iOS 支持本地发布队列，Android 当前使用前台上传流程。",
      "位置与日历：位置用于天气等相关功能。iOS 在你使用日历导出时请求相应权限；Android 通过 ICS 文件导出，不申请系统日历写入权限。"
    ]
  },
  {
    id: "purpose",
    title: "处理目的",
    items: [
      "从学校系统请求并显示课表、成绩、考试、学习计划与教室信息。",
      "在当前设备保存最近一次成功同步的数据，便于离线查看。",
      "提供社区资料、发帖、图片与附件上传、分层评论、点赞、通知、公告、反馈与评价。",
      "在你主动发布后，通过 7 天有效、仅可使用一次的邀请码共享只读课表。",
      "处理同步失败、登录、解析与社区服务问题。",
      "通过删除机制、发布限制、图片限制与必要的安全记录维护社区安全。"
    ]
  },
  {
    id: "third-party",
    title: "第三方服务",
    items: [
      "北京林业大学教务系统用于学校登录与教务数据查询。",
      "阿里云为新版 MyLeafy 提供账号服务运行环境、社区数据和文件存储，以及通知、反馈、评价、共享课表等功能。尚未迁移的旧版客户端继续使用 Supabase。",
      "阿里云为 myleafy.space 提供官网访问和域名解析。Cloudflare 暂时继续提供 support@myleafy.space 邮件转发。Resend 用于发送账号及邮箱验证邮件。",
      "Apple 与 Android 系统能力用于照片与文件选择、位置、系统分享、通知与本地存储；Apple CloudKit 用于用户主动开启的 iCloud 同步，不上传学校密码、Cookie 或登录令牌。iOS 通过 App Store 分发；Android 使用部署在阿里云上的 MyLeafy 版本与下载服务，GitHub Releases 同步发布相同安装包。版本检查和下载请求会携带网络连接所需的 IP 地址及应用包名，不包含学校账号或本地记录。"
    ]
  },
  {
    id: "retention",
    title: "保留与删除",
    items: [
      "本地设备数据保存在当前设备。iOS 开启 iCloud 后，范围内的修改和删除同步到同一 Apple 账号的相同校园身份。关闭同步保留本机和云端数据；可在 iCloud 设置页单独删除此身份云端数据。清理本机缓存会先暂停同步，避免清除云端副本。你可以在 App 中清理课表、成绩、笔记、提醒、收藏与相关缓存。",
      "退出登录会清除学校与社区的登录状态。保存在设备上的课表和成绩可能继续保留，以便离线查看，直至你主动清理。",
      "分享者可以撤销共享课表访问，查看者也可以移除已接受的课表；未使用的邀请码会自动过期。",
      "社区帖子与评论删除后，可能继续保留必要的通知和安全记录。删除的帖子图片和附件通常保留 30 天；未解决的举报或管理隐藏状态会暂停文件清理。",
      "未完成的社区上传草稿会在 24 小时后删除。附件类型与容器校验不等同于恶意软件或病毒扫描。",
      "你可以通过 App 内反馈或 support@myleafy.space 请求访问、更正或删除社区资料、反馈或内容数据。"
    ]
  },
  {
    id: "privacy-rights",
    title: "隐私选择与权利",
    items: [
      "是否完善社区资料由你决定，但发帖、评论与点赞需要设置社区昵称。",
      "共享课表由你主动发布，你可以随时停止分享或撤销查看者。",
      "照片、文件、位置与日历权限由你控制；无需这些权限的课表、成绩、教务工具与社区功能仍可独立使用。",
      "提交请求时，请说明需要访问、更正或删除的数据。我们可能通过 App 内登录状态或其他合理方式确认你的身份。"
    ]
  },
  {
    id: "security",
    title: "安全与限制",
    items: [
      "MyLeafy 仅为上述功能处理必要数据，但学校页面调整、校园网络限制与第三方服务中断仍可能影响可用性。",
      "请勿在支持请求中发送学校密码、验证码或完整身份证件。",
      "社区媒体的访问方式取决于版本：iOS 私有媒体通过有时效的授权链接读取；当前 Android 图片帖使用公开图片地址，拿到地址的人可能访问图片。请不要上传隐私资料。附件类型检查不等同于病毒扫描，仅打开可信来源的文件。"
    ]
  },
  {
    id: "contact",
    title: "联系我们",
    items: [
      "支持与隐私请求：support@myleafy.space。",
      "你也可以在 App 中打开“我的 → 支持 → 反馈”。",
      "运营者：MyLeafy Developer，公开开发者名称以 App Store 产品页为准。",
      `最后更新：${privacyUpdatedAt}。`
    ]
  }
];
